import pagesSync from './pages.sync.js'

export function getPages() {
  let pages = {}
  try {
    pages = pagesSync
  } catch {
    // Do nothing
  }
  return pages
}
